import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skelitions',
  templateUrl: './skelitions.component.html',
  styleUrls: ['./skelitions.component.scss']
})
export class SkelitionsComponent {
  @Input() value : any

  tableList : any[] | any;
  ngOnInit(){
    this.tableList = Array.from({ length: 8 }).map((_, i) => `Item #${i}`);

  }
}
